export const SHOW_POPUP = 'SHOW_CONFIRM';
export const HIDE_POPUP = 'HIDE_CONFIRM';

export const initialState = {
    open: false,
    onCloseActions: () => {
    },
    width: 'auto',
    height: 'auto',
    presentation: "",
    returnValue: "",
    name: "",
    inParam: {},
    popups: {}, // [name]: {...properties}
    availablePopups: new Set([])
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SHOW_POPUP:
            let availableSet = new Set(state.availablePopups);
            availableSet.add(action.payload.name);
            return {
                popups: {
                    ...state.popups,

                    [action.payload.name]: {
                        open: true,
                        ...action.payload
                    },
                },
                availablePopups: availableSet
            };
        case HIDE_POPUP:
            return {
                ...state,
                popups: {
                    ...state.popups,
                    [action.payload.name]: {
                        ...state.popups[action.payload.name],
                        open: false,

                    }
                },
            };
        default:
            return initialState;
    }
};